module.exports = __webpack_public_path__ + "img/admin.ca08800a.png";